class BackToTop extends HTMLElement {
  defaults = {
    root: null,
    rootMargin: '0px',
    threshold: 0.2,
  };

  constructor() {
    super();
    this.target = document.querySelector('#main-collection-filters');
    this.intersectionObserver = new IntersectionObserver(
      (entries) => this.processIntersectionEntries(entries),
      this.defaults
    );

    this.lastScrollTop = 0;
    this.isScrollingUp = false;
    this.filtersOutOfView = false;
  }

  connectedCallback() {
    if (this.target) {
      this.intersectionObserver.observe(this.target);
    }
    this.addScrollListener();
    this.addClickHandler();
  }

  disconnectedCallback() {
    if (this.target) {
      this.intersectionObserver.unobserve(this.target);
    }
    this.removeScrollListener();
    this.removeClickHandler();
  }

  addScrollListener() {
    window.addEventListener('scroll', this.handleScroll.bind(this), { passive: true });
  }

  removeScrollListener() {
    window.removeEventListener('scroll', this.handleScroll.bind(this));
  }

  addClickHandler() {
    const link = this.querySelector('a');
    if (link) {
      link.addEventListener('click', this.handleClick.bind(this));
    }
  }

  removeClickHandler() {
    const link = this.querySelector('a');
    if (link) {
      link.removeEventListener('click', this.handleClick.bind(this));
    }
  }

  handleClick(event) {
    event.preventDefault();

    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  }

  handleScroll() {
    const currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;

    this.isScrollingUp = currentScrollTop < this.lastScrollTop;

    this.updateVisibility();

    this.lastScrollTop = currentScrollTop;
  }

  processIntersectionEntries(entries) {
    entries.forEach((entry) => {
      this.filtersOutOfView = !entry.isIntersecting;
      this.updateVisibility();
    });
  }

  updateVisibility() {
    this.classList.toggle('is-visible', this.isScrollingUp && this.filtersOutOfView);
  }
}

customElements.define('back-to-top', BackToTop);
